export const PopupQuery = `
    query popup($canonicalUid: [String]) {
        ds_PopupsEntries(uid: $canonicalUid) {
            ... on ds_PopupsSection_Entry {
                id
                title
                contentType
                image {
                    id
                    url
                    alt
                    focalPoint
                }
                heading
                subheading
                bodyText
                button {
                    text
                    target
                    url
                }
                colorTheme
                colorPalette
                entry {
                    __typename
                    ... on ds_News_Entry {
                        id
                        url
                        title
                        articleExcerpt
                        image {
                            id
                            url @transform(width: 1000, height: 600)
                            alt
                            focalPoint
                        }
                    }
                    ... on ds_Events_Entry {
                        id
                        url
                        title
                        location
                        eventExcerpt
                        startDate
                        endDate
                        image {
                            id
                            url @transform(width: 1000, height: 600)
                            alt
                            focalPoint
                        }
                        startDate
                        endDate
                    }
                }
            }
        }
    }

`
